<template>
  <v-row class="pa-4">
    <p class="checkbox-label" data-qa="enabled-checkbox-label">{{ $t("enabled") }}</p>
      <v-checkbox density="compact" color="primary" false-icon="ecc:ecc-D-QuadOFF" true-icon="ecc:ecc-D-QuadON"
        hide-details v-model="action.enabled" data-qa="enabled-checkbox" />
  </v-row>
  <!-- Token -->
  <v-row class="my-0">
    <v-col class="py-1 pr-0">
      <v-text-field
        required
        data-qa="trigger-action-telegramConfig-token"
        v-model="action.telegramConfig.token"
        :label="$t('token')"
        :disabled="isUpdating"
        hide-details
      />
    </v-col>
  </v-row>
  <!-- ChatId -->
  <v-row class="my-0">
    <v-col class="py-1 pr-0">
      <v-text-field
        required
        data-qa="trigger-action-telegramConfig-chatId"
        v-model="action.telegramConfig.chatId"
        :label="$t('chatId')"
        :disabled="isUpdating"
        hide-details
      />
    </v-col>
  </v-row>
  <!-- body  -->
  <v-row class="my-0">
    <v-col class="py-1 pr-0">
      <div>Body</div>
      <MustacheEditor
        owner="template-mustache"
        v-model="action.telegramConfig.template"
        @update:value="updateValue"
        :width="440"
        :height="250"
        dataQa="template-mustache"
        refName="template"
      ></MustacheEditor>
    </v-col>
  </v-row>
  <!-- x-days -->
  <TriggerActionXdaysComponent class="pa-0" :config="action.telegramConfig" />
</template>

<script lang="ts">
import MustacheEditor from '../UIComponents/MustacheEditor.vue';
import { defineComponent } from "vue";
import { TriggerTelegramAction } from "./type.util";
import TriggerActionXdaysComponent from './TriggerActionXdaysComponent.vue';

export default defineComponent({
  name: "TriggerActionTelegramComponent",
  components: {
    MustacheEditor,
    TriggerActionXdaysComponent,
  },
  data() {
    return {
      isUpdating: false,
    };
  },
  props: {
    action: {
      type: Object as () => TriggerTelegramAction,
      default: null,
    },
  },
  computed: {
    canEnterExtraFilters: function (): string {
      return this.headerKey && this.headerValue;
    },
  },
  methods: {
    deleteActionConfirmation(): void {
      this.$emit("deleteActionConfirmation", this.action);
    },
    updateValue(value){
      this.action.telegramConfig.template = value;
    },
  },
});
</script>

<style scoped>
.header {
  font-weight: bold;
}
.checkbox-list {
  width: 100%;
}
.checkbox-label {
  line-height: 40px;
  width: 60px;
}
.max-100 {
  max-width: 100%;
}
.ellipsis-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}
.email-text-area.v-textarea >>> textarea {
  border: 1px solid var(--color-g4);
  padding: 20px 8px 2px 8px;
  margin-top: 10px;
  line-height: 1.1rem;
}
.policy-header {
  color: var(--color-g4);
}
.ecc.v-chip .close {
  color: var(--color-dk) !important;
}
</style>


